module.exports = __webpack_public_path__ + "static/media/teoLogo2Blanc.31be793e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teoLogo2Blanc.png
// module id = 1869
// module chunks = 0